import _ from 'lodash';
import React, { Component } from 'react';

import { StarRating } from '../shared';

import {
  getFourboxTalentCategories,
  getDefaultTalentRatingExplanationForValue
} from '../../util';
import {
  getIcon
} from '../../util/icons';

import ReactTooltip from 'react-tooltip';

class ReviewTalentCard extends Component {

  state = {
    evaluatedTalents: [],
  }

  getJointScoreForTalentId(talentId){
    return this.props.jointReview ? this.props.jointReview.ratings[talentId] : 0;
  }
  getSelfScoreForTalentId(talentId){
    return this.props.selfReview ? this.props.selfReview.ratings[talentId] : 0;
  }
  getManagerScoreForTalentId(talentId){
    return this.props.managerReview ? this.props.managerReview.ratings[talentId] : 0;
  }

  evaluatedTalents(){
    const allTalents = this.props.allTalents;

    const evaluatedTalents = _.filter(allTalents, organizationTalent => {

      if( this.getJointScoreForTalentId(organizationTalent.id) ||
          this.getSelfScoreForTalentId(organizationTalent.id) ||
          this.getManagerScoreForTalentId(organizationTalent.id)
      ){
        return true;
      }

      return false;
    });

    return evaluatedTalents;
  }

  talentsForCategory(category){
    //use this state talents
    return _.filter(this.evaluatedTalents(), talent => {
      return talent.category === category;
    });
  }

  renderTalentRatings(talent){
    const selfReviewPending = this.props.managerReview && !this.props.selfReview;
    const managerReviewPending = this.props.selfReview && !this.props.managerReview;

    const {
      isOwnCard,
      period,
      jointReview
    } = this.props;

    //viewing joint scores
    if(period === 'Initial'){

      const selfScore = this.getSelfScoreForTalentId(talent.id);
      const managerScore = this.getManagerScoreForTalentId(talent.id);

      if(isOwnCard){
        //self "initial"
        return (
          <div className="talent-ratings multiple">
            <div className="talent-rating">
              <StarRating
                ratingLabel={'Your initial rating'}
                className="self my-rating"
                maxRating={7}
                currentRating={selfScore}
                ratingExplanation={talent.ratings ? talent.ratings[selfScore - 1] : getDefaultTalentRatingExplanationForValue(selfScore)}
              />
            </div>
            <StarRating
              ratingLabel={!managerScore ? 'Manager Review Pending...' : 'Manager Rating'}
              className="manager not-my-rating"
              maxRating={7}
              currentRating={managerScore}
              ratingExplanation={(managerScore && talent.ratings) ? talent.ratings[managerScore - 1] : getDefaultTalentRatingExplanationForValue(managerScore)}
            />
          </div>
        )
      }
      else{
        //manager "initial"
        return (
          <div className="talent-ratings multiple">
            <div className="talent-rating">
              <StarRating
                ratingLabel={'Your initial rating'}
                ratingLabel={!selfScore ? 'Employee Review Pending...' : 'Employee Rating'}
                className="self not-my-rating"
                maxRating={7}
                currentRating={selfScore}
                ratingExplanation={(selfScore && talent.ratings) ? talent.ratings[selfScore - 1] : getDefaultTalentRatingExplanationForValue(selfScore)}
              />
            </div>
            <StarRating
              ratingLabel={'Your initial rating'}
              className="manager my-rating"
              maxRating={7}
              currentRating={managerScore}
              ratingExplanation={talent.ratings ? talent.ratings[managerScore - 1] : getDefaultTalentRatingExplanationForValue(managerScore)}
            />
          </div>
        )
      }
    }
    else if(jointReview){

      const jointScore = this.getJointScoreForTalentId(talent.id);

      return (
        <div className="talent-ratings">
          <div className="talent-rating">
            <StarRating
              ratingLabel={'Joint Rating'}
              maxRating={7}
              currentRating={jointScore}
              ratingExplanation={talent.ratings ? talent.ratings[jointScore - 1] : getDefaultTalentRatingExplanationForValue(jointScore)}
            />
          </div>
        </div>
      )
    }
    //user viewing
    else if(isOwnCard){

      const selfScore = this.getSelfScoreForTalentId(talent.id);
      const managerScore = this.getManagerScoreForTalentId(talent.id);

      return (
        <div className="talent-ratings multiple">
          <div className="talent-rating">
            <StarRating
              ratingLabel={selfReviewPending ? 'Your Review Pending...' : 'Your Rating'}
              className="self my-rating"
              maxRating={7}
              currentRating={selfScore}
              ratingExplanation={(!selfReviewPending && talent.ratings) ? talent.ratings[selfScore - 1] : getDefaultTalentRatingExplanationForValue(selfScore)}
            />
          {this.props.period !== 'Initial' &&
            <StarRating
              ratingLabel={managerReviewPending ? 'Manager Review Pending...' : 'Manger Rating'}
              className="manager not-my-rating"
              maxRating={7}
              currentRating={managerScore}
              ratingExplanation={(!managerReviewPending && talent.ratings) ? talent.ratings[managerScore - 1] : getDefaultTalentRatingExplanationForValue(managerScore)}
            />
          }
          </div>
        </div>
      )
    }
    //manager viewing
    else{

      const selfScore = this.getSelfScoreForTalentId(talent.id);
      const managerScore = this.getManagerScoreForTalentId(talent.id);

      return (
        <div className="talent-ratings multiple">
          <div className="talent-rating">
            <StarRating
              ratingLabel={selfReviewPending ? 'Employee Review Pending...' : 'Employee Rating'}
              className="self not-my-rating"
              maxRating={7}
              currentRating={selfScore}
              ratingExplanation={(!selfReviewPending && talent.ratings) ? talent.ratings[selfScore - 1] : getDefaultTalentRatingExplanationForValue(selfScore)}
            />
            <StarRating
              ratingLabel={managerReviewPending ? 'Your Review Pending...' : 'Your Rating'}
              className="manager my-rating"
              maxRating={7}
              currentRating={managerScore}
              ratingExplanation={(!managerReviewPending && talent.ratings) ? talent.ratings[managerScore - 1] : getDefaultTalentRatingExplanationForValue(managerScore)}
            />
          </div>
        </div>
      )
    }
  }

  talentIsFocused(talent){
    return _.find(this.props.focusedTalents, matchingTalent => {
      return matchingTalent.id === talent.id;
    }) ? true : false;
  }

  renderTalent(talent){

    const talentIsFocused = this.talentIsFocused(talent);

    return(
      <div key={talent.id} className="talent">
        <div className="talent-info">
          {talentIsFocused &&
            <div className="focus-icon" data-tip="Current sprint goal">{getIcon('sprint')}</div>
          }
          <div className="talent-name">{talent.name}</div>
          <div className="talent-definition">{talent.definition || `Example definition for ${talent.name}`}</div>
        </div>
        {this.renderTalentRatings(talent)}
      </div>
    )
  }

  render(){
    return(
      <div className="talent-evaluation-review">
        <div className="organization-talents">
          {_.map(getFourboxTalentCategories(), talentCategory => {
            return (
              <div key={talentCategory.key} className="talent-category">
                <div className="talents-section-header">{talentCategory.name}</div>
                {_.map(this.talentsForCategory(talentCategory.key), this.renderTalent.bind(this))}
              </div>
            );
          })}
        </div>
        <ReactTooltip effect="solid" place="top"/>
      </div>
    );
  }

}

export default ReviewTalentCard;



// WEBPACK FOOTER //
// ./src/components/talents/reviewTalentEvaluation.js